<app-selectie [(items)]="telefoonItems" [(huidigeSelectie)]="huidigeSelectie" [placeholder]="placeholder"
  [filterAltijdTonen]="filterAltijdTonen" (notifyAntwoordChanged)="notifyAntwoord($event)">
</app-selectie>